import SocialBar from "./SocialBar";
function LeftBarHero() {
    return (
        <div className="left-bar-hero">
            <div className="left-bar-hero-content">
                <h1 className="left-bar-hero-title">Need A Mentor?</h1>
                <p className="left-bar-hero-subtitle">We provide the best quality mentors and yes, we do take care of our beloved mentors.
You can transfer your head stress on us and relax...</p>
                <SocialBar></SocialBar>
            </div>
        </div>
    );
}
export default LeftBarHero;